import { IQuickSortContext } from './IQuickSortContext';
import { IQuickSortState } from './IQuickSortState';
import { QuickSortStep } from './enums/QuickSortStep';

class QuickSortContext implements IQuickSortContext {
  
  Numbers: number[] | undefined;
  Lo: number | undefined;
  Hi: number | undefined;
  Pivot: number | undefined;
  ICount: number | undefined;
  JCount: number | undefined;
  PartitionIndex: number | undefined;
  
  private states : Array<IQuickSortState> | undefined; 
  private _state : IQuickSortState;
  public IsEnd : boolean;
  public AlgoStack : Array<any> | undefined;  
  public SortedIndices : Array<number> | undefined;

  SkipPartition : boolean | undefined;

  constructor(state : IQuickSortState) {
    this.SetupNumbers();
    this.SetupLo();
    this.SetupHi();
    
    this.AlgoStack = [];
    this.SortedIndices = [];
    
    this.SkipPartition = false;

    this.IsEnd = false;

    this._state = state;

    this.states = [];
    this.states.push(this._state);

    this._state.SetContext(this);
    this._state.Do();
  }

  SetupNumbers() {
    this.Numbers = [2, 32, 3, 5, 1, 5, 3, 7];
    // this.Numbers = [2, 2, 2, 2, 2, 2, 2, 2, 2];
    // this.Numbers = [2, 9, 3, 5, 1, 4, 3, 6];
  }

  SetupLo() {
    this.Lo = 0;
  }

  SetupHi() {
    if (this.Numbers) 
      this.Hi = this.Numbers.length - 1;
  }

  TransitionTo(state: IQuickSortState): void {
    this._state = state;
    this.states?.push(this._state);
    this._state.SetContext(this);
    this._state.Do();
  }

  StepForward() : void {
    if (this.SkipPartition) {
      this.StepForwardSkipPartition()
    } else {
      this.StepForwardSingle();
    }
  }

  StepBackward() : void {
    if (this.SkipPartition) {
      this.StepBackwardSkipPartition()
    } else {
      this.StepBackwardSingle();
    }
  }

  get StepName () {
    return this._state.Description;
  }

  get ContextQuickSortStep () {
    return this._state.ThisQuickSortStep;
  }

  StepForwardSingle() {
    if (this.IsEnd)
      return;
    this._state.Exit();
  }
  
  StepForwardSkipPartition() {
    let partitionSteps : Array<QuickSortStep> = [
      QuickSortStep.PartitionEntry,
      QuickSortStep.PartitionAssignPivot,
      QuickSortStep.PartitionAssignICount,
      QuickSortStep.PartitionAssignJCount,
      QuickSortStep.PartitionLoopCompareJCountHI,
      QuickSortStep.PartitionLoopCompareJCountPivot,
      QuickSortStep.PartitionLoopIncrementICount,
      QuickSortStep.PartitionLoopSwapICountJCount,
      QuickSortStep.PartitionLoopIncrementJCount,
      QuickSortStep.PartitionSwapPivotICount
    ];

    if (partitionSteps.includes(this._state.ThisQuickSortStep)) {
      do {
        this.StepForwardSingle();
      } while (this._state.ThisQuickSortStep !== QuickSortStep.PartitionReturnPivot);
    }
    else {
      this.StepForwardSingle();
    }
  }

  StepBackwardSingle() {
    if (this.states?.length === 1)
      return;

    this._state.Undo();
    this.states?.pop();
    if (this.states) {
      this._state = this.states[this.states.length - 1];
    }

    this.IsEnd = false;
  }

  StepBackwardSkipPartition() {
    let partitionSteps : Array<QuickSortStep> = [     
      QuickSortStep.PartitionAssignPivot,
      QuickSortStep.PartitionAssignICount,
      QuickSortStep.PartitionAssignJCount,
      QuickSortStep.PartitionLoopCompareJCountHI,
      QuickSortStep.PartitionLoopCompareJCountPivot,
      QuickSortStep.PartitionLoopIncrementICount,
      QuickSortStep.PartitionLoopSwapICountJCount,
      QuickSortStep.PartitionLoopIncrementJCount,
      QuickSortStep.PartitionSwapPivotICount,
      QuickSortStep.PartitionReturnPivot,
    ];

    if (partitionSteps.includes(this._state.ThisQuickSortStep)) {
      do {
        this.StepBackwardSingle();
      } while (this._state.ThisQuickSortStep !== QuickSortStep.PartitionEntry);
    }
    else {
      this.StepBackwardSingle();
    }
  }
}

export { QuickSortContext }